import { BlockNodes, type IMenuButton } from '@principle-theorem/editor';
import { type MenuButtonLoaderFn } from '@principle-theorem/ng-prosemirror';
import { BasicMenuButtonComponent } from '../../menu-bar/basic-menu-button/basic-menu-button.component';

export const ORDERED_LIST_KEYMAP = 'Shift-Mod-7';

const data: IMenuButton = {
  buttonType: 'basic',
  buttonText: 'Ordered List',
  tooltip: 'Ordered List',
  shortcut: ORDERED_LIST_KEYMAP,
  icon: 'format_list_numbered',
  command: (editor) => editor.chain().focus().toggleOrderedList().run(),
  isActiveFn: (editor) => editor.isActive(BlockNodes.OrderedList),
};

export function createOrderedListMenuButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data,
  });
}

export function createOrderedListBlockMenuButton(): MenuButtonLoaderFn<
  BasicMenuButtonComponent,
  IMenuButton
> {
  return () => ({
    component: BasicMenuButtonComponent,
    data: {
      ...data,
      buttonType: 'block',
    },
  });
}
